import { calculateProduction } from './pokemonMaths';
import { NATURES } from './gameData';

// Weights to score specific subskills based on the Pokémon's role
const SUBSKILL_WEIGHTS = {
  berry: {
    'Berry Finding S': 5,
    'Helping Bonus': 4,
    'Helping Speed M': 3,
    'Helping Speed S': 1
  },
  ingredient: {
    'Ingredient Finder M': 4,
    'Helping Bonus': 4,
    'Inventory Up L': 3,
    'Ingredient Finder S': 2,
    'Inventory Up M': 2,
    'Helping Speed M': 2
  },
  skill: {
    'Skill Trigger M': 4,
    'Helping Bonus': 4,
    'Skill Level Up M': 3,
    'Skill Trigger S': 2,
    'Skill Level Up S': 2,
    'Helping Speed M': 2
  }
};

export function scorePokemon(mon, pokedex, role) {
  const species = pokedex[mon.species_id];
  if (!species) return null;

  // --- 1. Calculate Absolute & Baseline Production ---
  const simConfig = { energyStrategy: 'natural', inventoryMode: 'unlimited' };
  
  const currentProd = calculateProduction(species, mon, 24, simConfig);
  const baselineMon = { ...mon, nature: 'Serious', subskills: [] };
  const baselineProd = calculateProduction(species, baselineMon, 24, simConfig);

  let productionScore = 0;
  let baselineScore = 0;

  if (role === 'berry') {
    productionScore = currentProd.berries || 0;
    baselineScore = baselineProd.berries || 0;
  } else if (role === 'ingredient') {
    productionScore = Object.values(currentProd.ingredients || {}).reduce((a, b) => a + b, 0);
    baselineScore = Object.values(baselineProd.ingredients || {}).reduce((a, b) => a + b, 0);
  } else if (role === 'skill') {
    productionScore = parseFloat(currentProd.skills || 0);
    baselineScore = parseFloat(baselineProd.skills || 0);
  }

  // --- 2. Score Subskills ---
  let currentSubskillScore = 0;
  let ceilingSubskillScore = 0;
  const flags = [];
  const unlockLevels = [10, 25, 50, 75, 100];
  const weights = SUBSKILL_WEIGHTS[role] || {};

  mon.subskills.forEach((skill, i) => {
    if (!skill) return;
    const weight = weights[skill] || 0;
    
    ceilingSubskillScore += weight;
    if (mon.level >= unlockLevels[i]) {
      currentSubskillScore += weight;
    } else if (weight >= 3) {
      flags.push(`Strong subskills locked until higher level (Lv.${unlockLevels[i]})`);
    }

    if (skill === 'Helping Bonus' && !flags.includes('Helping Bonus — boosts whole team')) {
      flags.push('Helping Bonus — boosts whole team');
    }
  });

  // --- 3. Evaluate Nature ---
  const nature = NATURES[mon.nature] || {};
  if ((role === 'berry' || role === 'ingredient') && nature.down === 'Speed') flags.push('Speed− nature hurts production');
  if (role === 'ingredient' && nature.down === 'Ing') flags.push('Ingredient− nature hurts ingredient yields');
  if (role === 'skill' && nature.down === 'Skill') flags.push('Skill− nature is a strong negative for skill specialists');

  // --- 4. Derive Grade ---
  let grade = 'watch';
  const isHighProduction = productionScore >= baselineScore * 1.1;
  const isPoorProduction = productionScore <= baselineScore * 0.9;

  if (isHighProduction || currentSubskillScore >= 5) grade = 'invest';
  else if (isPoorProduction && ceilingSubskillScore <= 2) grade = 'release';

  return { grade, productionScore, currentSubskillScore, ceilingSubskillScore, flags };
}